window.Reverb = window.Reverb || {};

Reverb.PaypalProfile = (function () {
  const verificationSelector = 'pending-paypal-verification';
  const verificationDataSelector = `[data-${verificationSelector}]`;

  const verificationPendingSelector = '[data-verification-pending]';
  const verificationSuccessSelector = '[data-verification-success]';
  const verificationFailureSelector = '[data-verification-failure]';

  const verificationFormSelector = '[data-bind = \'paypal-verification-form\']';
  const verificationSubmitSelector = '[data-bind = \'paypal-verification-submit\']';
  const closeVerificationFormSelector = '[data-bind = \'close-paypal-form\']';

  const verificationSpinnerSelector = '[data-bind="paypal-verification-spinner"]';
  const verificationSuccessMessage = '[data-bind="paypal-verification-success"]';
  const verificationFailureMessage = '[data-bind="paypal-verification-failure"]';

  let timesChecked = 0;

  function checkVerificationStatus() {
    const elementsNeedingPaypalVerification = $(verificationDataSelector);

    if (elementsNeedingPaypalVerification.length > 0) {
      getAndCheckStatusRecursively();
    }
  }

  function bindVerificationFormSubmit() {
    $(document).on('submit', verificationFormSelector, (e) => {
      e.preventDefault();

      $(verificationSpinnerSelector).show();
      $(verificationFailureMessage).hide();
      verifyPaypalProfile();
    });
  }

  function verifyPaypalProfile() {
    var form = $(verificationFormSelector).children(form);
    const action = form.attr('action');

    $.post(action, form.serialize()).done((data) => {
      verificationSuccess();
    }).fail((xhr) => {
      verificationFailed();
    }).always(() => {
      $(verificationSpinnerSelector).hide();
    });
  }

  function verificationSuccess() {
    $(verificationSuccessMessage).show();
    $(closeVerificationFormSelector).show();
    $(verificationSubmitSelector).hide();
  }

  function verificationFailed() {
    $(verificationFailureMessage).show();
    $('[data-bind="paypal-verification-failure"]').show();
    $(verificationSubmitSelector).removeClass('btn-disabled');
    $(verificationSubmitSelector).removeAttr('disabled');
  }

  function getAndCheckStatusRecursively() {
    if (timesChecked < 30) {
      setTimeout(getAndCheckStatus, 1000);
      timesChecked++;
    }
  }

  function queryVerificationStatus(callback) {
    const url = $(verificationDataSelector).data(verificationSelector);

    $.get(url).done((data) => {
      callback(data.status);
    });
  }

  function getAndCheckStatus() {
    queryVerificationStatus((status) => {
      if (status === 'verified') {
        $(verificationPendingSelector).hide();
        $(verificationSuccessSelector).show();
      } else if (status === 'verification_failed') {
        $(verificationPendingSelector).hide();
        $(verificationFailureSelector).show();
      } else if (status === 'pending_verification') {
        getAndCheckStatusRecursively();
      }
    });
  }

  function init() {
    checkVerificationStatus();
    bindVerificationFormSubmit();
  }

  return {
    init,
  };
}());

$(Reverb.PaypalProfile.init);
